import { ExternalProvider, JsonRpcFetchFunc, Web3Provider } from '@ethersproject/providers'

export default function getLibrary(provider: JsonRpcFetchFunc | ExternalProvider): Web3Provider {
    const library = new Web3Provider(provider)
    library.pollingInterval = 15000
    return library
}
